export interface LegalDomainOption {
  value: string;
  labelKey: string;
}

export const LEGAL_CATEGORIES: LegalDomainOption[] = [
  { value: "CIVIL_LAW", labelKey: "LEGAL_CATEGORY_CIVIL_LAW" },
  { value: "COMMERCIAL_LAW", labelKey: "LEGAL_CATEGORY_COMMERCIAL_LAW" },
  { value: "LABOR_LAW", labelKey: "LEGAL_CATEGORY_LABOR_LAW" },
  { value: "CRIMINAL_LAW", labelKey: "LEGAL_CATEGORY_CRIMINAL_LAW" },
  { value: "ADMINISTRATIVE_LAW", labelKey: "LEGAL_CATEGORY_ADMINISTRATIVE_LAW" },
  { value: "TAX_LAW", labelKey: "LEGAL_CATEGORY_TAX_LAW" },
  { value: "REAL_ESTATE_LAW", labelKey: "LEGAL_CATEGORY_REAL_ESTATE_LAW" },
  { value: "FAMILY_LAW", labelKey: "LEGAL_CATEGORY_FAMILY_LAW" },
  { value: "CORPORATE_LAW", labelKey: "LEGAL_CATEGORY_CORPORATE_LAW" },
  { value: "INTERNATIONAL_LAW", labelKey: "LEGAL_CATEGORY_INTERNATIONAL_LAW" },
];

export const LEGAL_TYPES: LegalDomainOption[] = [
  { value: "LAW", labelKey: "LEGAL_TYPE_LAW" },
  { value: "DECREE", labelKey: "LEGAL_TYPE_DECREE" },
  { value: "ORDER", labelKey: "LEGAL_TYPE_ORDER" },
  { value: "CIRCULAR", labelKey: "LEGAL_TYPE_CIRCULAR" },
  { value: "ORDINANCE", labelKey: "LEGAL_TYPE_ORDINANCE" },
  { value: "REGULATION", labelKey: "LEGAL_TYPE_REGULATION" },
  { value: "CODE", labelKey: "LEGAL_TYPE_CODE" },
  { value: "CASE_LAW", labelKey: "LEGAL_TYPE_CASE_LAW" },
  { value: "DOCTRINE", labelKey: "LEGAL_TYPE_DOCTRINE" },
  { value: "STANDARD_CONTRACT", labelKey: "LEGAL_TYPE_STANDARD_CONTRACT" },
];

export interface CountryOption {
  id: string;
  value: string;
  labelKey: string;
}

export const LEGAL_COUNTRIES: CountryOption[] = [
  { id: "2542007", value: "MOROCCO", labelKey: "LEGAL_COUNTRY_MOROCCO" },
  { id: "3017382", value: "FRANCE", labelKey: "LEGAL_COUNTRY_FRANCE" },
  { id: "2802361", value: "BELGIUM", labelKey: "LEGAL_COUNTRY_BELGIUM" },
  { id: "2658434", value: "SWITZERLAND", labelKey: "LEGAL_COUNTRY_SWITZERLAND" },
  { id: "6251999", value: "CANADA", labelKey: "LEGAL_COUNTRY_CANADA" },
  { id: "2464461", value: "TUNISIA", labelKey: "LEGAL_COUNTRY_TUNISIA" },
  { id: "2589581", value: "ALGERIA", labelKey: "LEGAL_COUNTRY_ALGERIA" },
  { id: "2245662", value: "SENEGAL", labelKey: "LEGAL_COUNTRY_SENEGAL" },
  { id: "2287781", value: "IVORY_COAST", labelKey: "LEGAL_COUNTRY_IVORY_COAST" },
  { id: "2960313", value: "LUXEMBOURG", labelKey: "LEGAL_COUNTRY_LUXEMBOURG" },
];

/** Resolve the i18n labelKey from a category value key */
export function getCategoryLabelKey(value: string): string {
  return LEGAL_CATEGORIES.find((c) => c.value === value)?.labelKey ?? value;
}

/** Resolve the i18n labelKey from a type value key */
export function getTypeLabelKey(value: string): string {
  return LEGAL_TYPES.find((t) => t.value === value)?.labelKey ?? value;
}

/** Resolve the i18n labelKey from a country value key */
export function getCountryLabelKey(value: string): string {
  return LEGAL_COUNTRIES.find((c) => c.value === value)?.labelKey ?? value;
}

/** Tailwind color classes indexed by category value */
export const CATEGORY_COLORS: Record<string, string> = {
  CIVIL_LAW: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300",
  COMMERCIAL_LAW: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300",
  LABOR_LAW: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300",
  CRIMINAL_LAW: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300",
  ADMINISTRATIVE_LAW: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300",
  TAX_LAW: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300",
  REAL_ESTATE_LAW: "bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300",
  FAMILY_LAW: "bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-300",
  CORPORATE_LAW: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300",
  INTERNATIONAL_LAW: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-300",
};

export function getCategoryColorClass(value: string): string {
  return (
    CATEGORY_COLORS[value] ??
    "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300"
  );
}
